import React from 'react'
import LayoutHome from '../../components/layout/LayoutHome';

const Nomina = () => {
  return (
    <LayoutHome pageSeleccionada="nomina">
      <div>Nomina</div>
    </LayoutHome>
  )
}

export default Nomina;